var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgCircleRight(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 30 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M24.75 11.977c0-3.47-1.875-6.657-4.875-8.438-3.047-1.734-6.75-1.734-9.75 0C7.078 5.32 5.25 8.508 5.25 11.977c0 3.515 1.828 6.703 4.875 8.484 3 1.734 6.703 1.734 9.75 0 3-1.781 4.875-4.969 4.875-8.484zm-21.75 0a11.91 11.91 0 016-10.36c3.703-2.156 8.25-2.156 12 0 3.703 2.156 6 6.094 6 10.36 0 4.312-2.297 8.25-6 10.406-3.75 2.156-8.297 2.156-12 0-3.75-2.156-6-6.094-6-10.406zm13.781-5.625l4.688 5.015c.187.14.281.375.281.61 0 .28-.094.468-.281.656l-4.688 5.015c-.187.235-.468.329-.75.329A1.04 1.04 0 0115 16.945v-2.718h-4.5a1.48 1.48 0 01-1.5-1.5v-1.5c0-.797.656-1.5 1.5-1.5H15V7.055c0-.61.469-1.078 1.031-1.078.282 0 .563.14.75.375z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgCircleRight);
export default ForwardRef;
